module.exports = __webpack_public_path__ + "img/12.fa5da424.png";